import { Link, useParams } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import { articles } from "@/mocks/articles";

export default function ArticleDetail() {
  const { id = "1" } = useParams();
  const article = articles.find((a) => a.id === Number(id)) || articles[0];
  const related = articles.filter((a) => a.id !== article.id).slice(0, 3);

  return (
    <Layout>
      <title>{article.title} | 可乐漫画</title>
      <meta name="description" content={article.excerpt} />
      <meta name="keywords" content={`可乐漫画,${article.category},${article.tags.join(",")},快乐水组合`} />
      <link rel="canonical" href={`https://lazymix.github.io/article/${article.id}`} />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          headline: article.title,
          description: article.excerpt,
          author: { "@type": "Organization", name: "可乐漫画" },
          datePublished: article.date,
          image: article.cover,
          keywords: article.tags.join(","),
        })}
      </script>

      <article className="mx-auto max-w-4xl px-4 py-10 md:px-6 md:py-14">
        <nav aria-label="面包屑" className="flex items-center gap-1.5 text-sm text-foreground-500">
          <Link to="/" className="hover:text-primary-600">首页</Link>
          <i className="ri-arrow-right-s-line" style={{ width: 16, height: 16 }} />
          <Link to="/list" className="hover:text-primary-600">追更榜单</Link>
          <i className="ri-arrow-right-s-line" style={{ width: 16, height: 16 }} />
          <span className="text-foreground-800">{article.category}</span>
        </nav>

        <header className="mt-5">
          <span className="text-sm font-medium text-accent-600">{article.category}</span>
          <h1 className="mt-2 font-heading text-2xl leading-snug text-foreground-950 md:text-4xl">
            {article.title}
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{article.excerpt}</p>
          <div className="mt-5 flex flex-wrap items-center gap-4 border-b border-background-200 pb-5 text-sm text-foreground-500">
            <span className="flex items-center gap-1.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-500 font-heading text-xs text-background-50">
                {article.author.slice(0, 1)}
              </span>
              {article.author}
            </span>
            <span>{article.date}</span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line" style={{ width: 14, height: 14 }} />
              {article.readTime}
            </span>
          </div>
        </header>

        <div className="mt-6 aspect-[16/9] w-full overflow-hidden rounded-lg">
          <img src={article.cover} alt={article.title} title={`${article.title} 快乐水追更`} className="h-full w-full object-cover" />
        </div>

        <div className="mt-8 space-y-5">
          {article.content.map((p, i) => (
            <p key={i} className="text-[15px] leading-8 text-foreground-800">
              {i === 0 ? <strong className="font-medium text-foreground-950">{article.title}，</strong> : null}
              {p}
            </p>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {article.tags.map((t) => (
            <span key={t} className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-900">
              # {t}
            </span>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-lg border border-background-200 bg-background-100 p-5 sm:flex-row">
          <div>
            <div className="text-sm font-medium text-foreground-950">觉得这篇有帮助？</div>
            <div className="mt-1 text-xs text-foreground-500">分享给同样爱配快乐水看漫画的朋友吧</div>
          </div>
          <div className="flex gap-2">
            {["ri-wechat-fill", "ri-weibo-fill", "ri-twitter-x-fill"].map((icon) => (
              <a
                key={icon}
                href="#contact"
                aria-label="分享文章"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className={icon} style={{ width: 16, height: 16 }} />
              </a>
            ))}
          </div>
        </div>
      </article>

      {/* 相关推荐 */}
      <section className="border-t border-background-200 bg-background-100 py-10 md:py-14">
        <div className="mx-auto max-w-4xl px-4 md:px-6">
          <h2 className="text-lg font-medium text-foreground-950 md:text-xl">更多追更指南</h2>
          <div className="mt-5 grid gap-5 md:grid-cols-3">
            {related.map((a) => (
              <Link
                key={a.id}
                to={`/article/${a.id}`}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200"
              >
                <div className="aspect-[16/9] w-full overflow-hidden">
                  <img
                    src={a.cover}
                    alt={a.title}
                    title={`${a.title} 追更配零食`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <span className="text-xs font-medium text-accent-600">{a.category}</span>
                  <h3 className="mt-1.5 line-clamp-2 text-sm font-medium text-foreground-950">{a.title}</h3>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}